export default "__VITE_ASSET__CLCQ17BX__";